/**
 * Legal identity and contact details, as required on every page by
 * apps/landing/docs/SWAMITHRA_Website_Content.docx (the content brief for
 * Google Play / App Store / Meta verification).
 *
 * FIELDS MARKED "[...]" ARE PLACEHOLDERS. The source doc lists them as
 * "[BRACKETS] = fill in real details" — CIN, the registered office, the
 * grievance officer's name, the jurisdiction city, the deletion turnaround,
 * and the policy date are unverifiable facts this change cannot invent.
 * Replace every one of them before launch; a wrong CIN or a fabricated
 * officer name is worse than a visible placeholder.
 */
export const COMPANY_LEGAL_NAME = "SWAMITHRA TAX KPO PRIVATE LIMITED"
export const COMPANY_BRAND = "Swamithra"

export const CIN = "[CIN]"
export const REGISTERED_OFFICE = "Hyderabad"
export const JURISDICTION_CITY = "Hyderabad"
export const DELETION_TURNAROUND = "[X business days]"
export const LAST_UPDATED_DATE = "12 September, 2026"
export const COPYRIGHT_YEAR = 2026

export const SUPPORT_EMAIL = "help@swamithra.com"
export const SUPPORT_PHONE = "+91 9014383577"
export const SUPPORT_PHONE_TEL = SUPPORT_PHONE
/** When the support number is answered, shown wherever it can be called. */
export const SUPPORT_CALL_HOURS = "Monday-Saturday. 10:00 am to 5:00 pm"
export const ADDRESS =
	"103, Sree Ramakrishna Towers, Nagarjuna Nagar, Yellareddyguda, Ameerpet, Hyderabad – 73."

export const GRIEVANCE_OFFICER_NAME = "K. Prudhvi"
export const GRIEVANCE_EMAIL = SUPPORT_EMAIL
